var _defs, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMind(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "svg3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#daa520",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    },
    id: "g4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5",
    transform: "translate(12.863831,-28.868829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.41763,18.5409 C 10.1913,17.3978 11.2839,16 12,16 c 0.7161,0 1.8087,1.3978 2.5824,2.5409 C 15.0129,19.1769 14.5438,20 13.7757,20 H 10.2243 C 9.45619,20 8.9871,19.1769 9.41763,18.5409 Z",
    fill: "#0f0f0f",
    id: "path1-5",
    style: {
      fill: "#daa520",
      fillOpacity: 0.466667,
      stroke: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,9 C 12.3511,9 12.9855,8.23437 13.5273,7.47668 13.9798,6.84397 13.5091,6 12.7313,6 H 11.2687 C 10.4909,6 10.0202,6.84397 10.4727,7.47668 11.0145,8.23437 11.6489,9 12,9 Z",
    fill: "#0f0f0f",
    id: "path2-4",
    style: {
      fill: "#daa520",
      fillOpacity: 0.466667,
      stroke: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 4,2 C 4,1.44772 4.44772,1 5,1 h 14 c 0.5523,0 1,0.44772 1,1 0,0.55228 -0.4477,1 -1,1 H 17.9726 C 17.8373,5.41131 17.21,7.23887 16.2903,8.7409 15.4882,10.0511 14.4804,11.0808 13.4874,12 c 0.993,0.9192 2.0008,1.9489 2.8029,3.2591 0.9197,1.502 1.547,3.3296 1.6823,5.7409 H 19 c 0.5523,0 1,0.4477 1,1 0,0.5523 -0.4477,1 -1,1 H 5 C 4.44772,23 4,22.5523 4,22 4,21.4477 4.44772,21 5,21 H 6.02739 C 6.16267,18.5887 6.79004,16.7611 7.70965,15.2591 8.51183,13.9489 9.51962,12.9192 10.5126,12 9.51962,11.0808 8.51183,10.0511 7.70965,8.7409 6.79004,7.23887 6.16267,5.41131 6.02739,3 H 5 C 4.44772,3 4,2.55228 4,2 Z M 15.9691,21 C 15.8384,18.9511 15.3049,17.4797 14.5846,16.3034 13.8874,15.1645 12.9954,14.2641 12,13.3497 11.0046,14.2641 10.1126,15.1645 9.41535,16.3034 8.69515,17.4797 8.1616,18.9511 8.03092,21 Z M 8.03092,3 H 15.9691 C 15.8384,5.04891 15.3049,6.52026 14.5846,7.6966 13.8874,8.83549 12.9954,9.73587 12,10.6503 11.0046,9.73587 10.1126,8.83549 9.41535,7.6966 8.69515,6.52026 8.1616,5.04891 8.03092,3 Z",
    fill: "#0f0f0f",
    id: "path3",
    style: {
      fill: "#daa520",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g11",
    transform: "matrix(0.04687495,0,0,0.04687495,-1.0637475e-5,1.28e-5)",
    style: {
      fill: "#daa520",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 502.472,256.833 C 495.981,195.758 461.782,146.373 416.39,112.732 370.503,78.692 313.094,60.008 258.715,59.972 c -56.443,0.009 -91.262,7.173 -114.312,17.082 -22.776,9.644 -33.774,22.98 -39.813,30.843 -24.68,4.029 -49.262,18.348 -68.77,38.697 C 15.107,168.343 0.054,197.423 0,229.381 c 0,34.97 8.112,64.52 24.299,86.498 14.354,19.596 35.288,32.472 60.207,37.148 1.638,9.456 5.56,20.003 13.672,29.647 8.412,10.06 19.888,17.383 33.454,22.032 13.584,4.675 29.329,6.836 47.234,6.853 h 75.084 c 1.85,4.729 4.108,9.236 7.217,13.213 7.642,9.785 18.649,16.656 31.834,20.96 13.248,4.33 28.859,6.288 46.995,6.296 8.909,0 17.348,-0.407 24.512,-0.752 h 0.026 c 5.136,-0.274 9.555,-0.469 12.698,-0.469 9.466,0 18.526,-2.302 26.318,-6.819 7.793,-4.498 14.257,-11.166 18.676,-19.357 2.232,-4.154 3.702,-8.51 4.8,-12.902 16.727,-3.126 30.604,-9.236 41.407,-17.028 12.663,-9.121 21.367,-20.11 27.283,-30.09 11.556,-19.552 16.267,-41.247 16.285,-61.384 -0.019,-17.163 -3.49,-33.147 -9.529,-46.394 z m -26.61,96.016 c -4.649,7.837 -11.352,16.241 -20.916,23.121 -9.581,6.872 -22.041,12.38 -39.06,14.319 l -9.519,1.072 -0.7,9.555 c -0.292,4.127 -1.576,8.767 -3.737,12.76 -2.506,4.578 -5.835,7.962 -9.918,10.335 -4.1,2.356 -9.006,3.71 -14.78,3.718 -4.073,0 -8.714,0.24 -13.858,0.496 l 1.922,-0.088 -1.914,0.088 c -7.145,0.355 -15.178,0.736 -23.386,0.736 -21.943,0.035 -38.299,-3.356 -48.747,-8.864 -5.251,-2.736 -9.06,-5.906 -11.884,-9.511 -2.807,-3.622 -4.711,-7.74 -5.782,-12.884 l -1.904,-9.218 h -92.812 c -16.01,0 -29.302,-1.992 -39.725,-5.578 -10.44,-3.622 -17.94,-8.678 -23.28,-15.054 -6.96,-8.306 -9.024,-17.32 -9.289,-25.237 l -0.31,-10.077 -10.024,-1.044 C 72.72,328.914 55.354,318.97 42.86,302.18 30.436,285.365 23.069,260.88 23.069,229.382 23.015,204.96 34.943,180.908 52.512,162.507 c 17.463,-18.454 40.46,-30.674 59.419,-32.463 l 4.348,-0.452 2.966,-3.206 c 1.328,-1.452 2.382,-2.851 3.294,-4.002 5.986,-7.474 12.114,-15.806 31.002,-24.139 18.845,-8.156 50.652,-15.222 105.174,-15.213 49.076,-0.036 102.278,17.232 143.932,48.217 41.726,31.046 71.78,75.153 77.094,129.578 l 0.203,2.098 0.922,1.887 c 4.844,9.776 8.094,23.608 8.066,38.414 0,16.55 -3.94,34.225 -13.07,49.623 z",
    id: "path1-58",
    style: {
      fill: "#daa520",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 357.042,146.417 h 24.059 c 5.172,0 9.378,-4.242 9.378,-9.573 0,-5.215 -4.206,-9.43 -9.378,-9.43 h -24.059 c -5.331,0 -9.555,4.216 -9.555,9.43 10e-4,5.331 4.224,9.573 9.555,9.573 z",
    id: "path2-3",
    style: {
      fill: "#daa520",
      fillOpacity: 0.466667
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 244.21,237.307 c 0,5.287 4.25,9.564 9.501,9.564 5.162,0 9.475,-4.276 9.475,-9.564 v -51.82 c 0,-2.399 0.709,-2.958 0.886,-3.179 3.02,-2.966 14.274,-2.966 22.164,-2.966 l 0.301,0.106 h 62.226 c 1.204,0 2.48,-0.106 3.906,-0.106 5.012,-0.221 11.202,-0.434 13.796,2.072 1.647,1.611 2.604,5.19 2.604,9.988 v 31.809 1.416 c -0.204,6.544 -0.24,17.56 7.128,25.042 2.869,2.958 8.2,6.464 16.896,6.464 h 48.89 c 5.136,0 9.352,-4.233 9.352,-9.555 0,-5.198 -4.216,-9.519 -9.352,-9.519 h -48.89 l -3.418,-0.806 c -1.736,-1.797 -1.621,-8.332 -1.621,-11.467 v -33.385 c 0,-10.307 -2.886,-18.277 -8.394,-23.599 -8.484,-8.138 -20.022,-7.801 -27.629,-7.483 -1.258,0 -2.302,0.045 -3.268,0.045 h -31.364 c 0.372,-2.622 0.372,-5.26 0.274,-7.633 v -27.602 c 0,-5.189 -4.268,-9.476 -9.448,-9.476 -5.286,0 -9.43,4.286 -9.43,9.476 v 27.752 c 0,2.222 0,5.738 -0.47,6.65 0,0 -1.301,0.832 -6.314,0.832 -1.442,0 -2.992,0 -4.684,0 -12.92,-0.16 -27.778,-0.204 -36.615,8.474 -2.887,2.922 -6.5,8.208 -6.5,16.648 v 51.822 z",
    id: "path3-0",
    style: {
      fill: "#daa520",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 213.677,159.709 c 5.304,0 9.555,-4.348 9.555,-9.528 v -13.594 h 15.93 c 5.154,0 9.413,-4.268 9.413,-9.554 0,-5.162 -4.259,-9.493 -9.413,-9.493 h -15.93 v -10.467 c 0,-5.233 -4.251,-9.528 -9.555,-9.528 -5.154,0 -9.413,4.294 -9.413,9.528 v 43.108 c 0,5.18 4.259,9.528 9.413,9.528 z",
    id: "path4",
    style: {
      fill: "#daa520",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 110.841,173.682 h 39.468 c 6.438,-0.229 12.565,-0.229 15.452,2.807 2.559,2.498 3.967,8.111 3.967,16.17 v 37.051 c 0,5.242 4.233,9.546 9.581,9.546 5.154,0 9.458,-4.303 9.458,-9.546 v -7.882 h 14.886 c 5.251,0 9.44,-4.277 9.44,-9.51 0,-5.251 -4.188,-9.599 -9.44,-9.599 h -14.886 v -10.06 c 0,-13.672 -3.135,-23.351 -9.626,-29.736 -8.421,-8.448 -19.8,-8.368 -28.877,-8.288 h -39.423 c -5.384,0 -9.511,4.312 -9.511,9.475 0,5.277 4.127,9.572 9.511,9.572 z",
    id: "path5",
    style: {
      fill: "#daa520",
      fillOpacity: 0.466667
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 135.892,229.099 c 0,-5.251 -4.365,-9.555 -9.483,-9.555 H 59.791 c -5.26,0 -9.555,4.304 -9.555,9.555 0,5.233 4.295,9.528 9.555,9.528 h 24.148 v 17.339 c 0,5.286 4.188,9.519 9.386,9.519 5.402,0 9.59,-4.233 9.59,-9.519 v -17.339 h 23.494 c 5.118,0 9.483,-4.296 9.483,-9.528 z",
    id: "path6",
    style: {
      fill: "#daa520",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 194.576,291.412 c 1.665,0 3.242,0 4.649,0 h 76.704 c 17.498,0 30.772,-4.64 39.6,-13.884 13.566,-14.363 12.619,-35.634 11.919,-49.687 -0.124,-2.683 -0.248,-5.206 -0.248,-7.323 0,-5.296 -4.25,-9.51 -9.608,-9.51 -5.18,0 -9.368,4.215 -9.368,9.51 0,2.408 0.124,5.171 0.248,8.111 0.584,12.256 1.24,27.337 -6.854,35.873 -4.941,5.26 -13.682,7.89 -25.689,7.89 h -76.704 c -1.337,0 -2.7,0 -4.348,0 -15.133,-0.23 -40.584,-0.638 -56.753,15.319 -9.068,8.944 -13.681,21.545 -13.681,37.396 0,5.153 4.17,9.52 9.484,9.52 5.18,0 9.51,-4.366 9.51,-9.52 0,-10.768 2.594,-18.579 8.049,-23.918 10.449,-10.255 30.126,-9.954 43.09,-9.777 z",
    id: "path7",
    style: {
      fill: "#daa520",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 323.96,332.616 c 0,-5.162 -4.171,-9.502 -9.475,-9.502 H 194.107 c -5.19,0 -9.538,4.34 -9.538,9.502 0,5.268 4.348,9.519 9.538,9.519 h 36.81 v 18.985 c 0,5.323 4.225,9.502 9.458,9.502 5.251,0 9.493,-4.179 9.493,-9.502 v -18.985 h 64.617 c 5.303,0 9.475,-4.251 9.475,-9.519 z",
    id: "path8",
    style: {
      fill: "#daa520",
      fillOpacity: 0.466667
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 377.887,370.065 h -4.471 v -17.693 c 0,-5.384 -4.18,-9.528 -9.475,-9.528 -5.26,0 -9.502,4.145 -9.502,9.528 v 17.693 h -32.941 c -5.242,0 -9.502,4.241 -9.502,9.528 0,5.224 4.26,9.448 9.502,9.448 h 56.39 c 5.208,0 9.484,-4.224 9.484,-9.448 -0.001,-5.288 -4.277,-9.528 -9.485,-9.528 z",
    id: "path9",
    style: {
      fill: "#daa520",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 421.579,323.114 v -15.523 h 3.419 c 5.357,0 9.599,-4.17 9.599,-9.43 0,-5.251 -4.242,-9.555 -9.599,-9.555 h -66.459 c -5.225,0 -9.511,4.304 -9.511,9.555 0,5.26 4.286,9.43 9.511,9.43 h 43.983 v 15.523 c 0,5.358 4.313,9.502 9.556,9.502 5.233,0 9.501,-4.144 9.501,-9.502 z",
    id: "path10",
    style: {
      fill: "#daa520",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 451.333,347.909 h -24.042 c -5.304,0 -9.546,4.18 -9.546,9.467 0,5.286 4.241,9.43 9.546,9.43 h 24.042 c 5.33,0 9.616,-4.144 9.616,-9.43 10e-4,-5.287 -4.286,-9.467 -9.616,-9.467 z",
    id: "path11",
    style: {
      fill: "#daa520",
      fillOpacity: 0.466667
    }
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1"
  }, "\n\t.st0{fill:#000000;}\n")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMind);
export default __webpack_public_path__ + "static/media/mind.b35a8aac441f6e84a6526a87e086e349.svg";
export { ForwardRef as ReactComponent };